import { render, staticRenderFns } from "./zxpersonInfo.vue?vue&type=template&id=177d5fb4&scoped=true&"
import script from "./zxpersonInfo.vue?vue&type=script&lang=js&"
export * from "./zxpersonInfo.vue?vue&type=script&lang=js&"
import style0 from "./zxpersonInfo.vue?vue&type=style&index=0&id=177d5fb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177d5fb4",
  null
  
)

export default component.exports